export default "__VITE_ASSET__c85a843d__"